import { RefObject, useCallback } from 'react';

import { useTelegramMiniApp } from 'app/_context/TelegramContext';

export const useAdditionalFormSpace = (ref: RefObject<HTMLFormElement>) => {
  const { isEnabledTWA } = useTelegramMiniApp();

  const handleFocus = useCallback(() => {
    if (isEnabledTWA) {
      ref.current?.classList.add('pb-[300px]');
    }
  }, [isEnabledTWA, ref]);

  const handleBlur = useCallback((onBlur: () => void) => {
    onBlur();

    if (isEnabledTWA) {
      ref.current?.classList.remove('pb-[300px]');
    }
  }, [isEnabledTWA, ref]);

  return {
    handleFocus,
    handleBlur,
  };
};
